export default __webpack_public_path__ + "static/media/WesbrookVillageMedical.d8579610.png";